define.alias("shared/components/shared/plan-recommendation/index", "calendar/components/shared/plan-recommendation/index");